<template>
  <div class="nav-menu">
    <div class="nav-menu-group">
      <div class="nav-menu-item" :class="{'select': activeIndex === 1 }"
        @click="navMenuSelect(1, '/bigdata/home')">
        <div style="display: flex; align-items: center;">
          <img src="@/assets/images/icon-home.png"
            style="width: 1rem; height: 1rem;"/>
          <span>&nbsp;首页</span>
        </div>
      </div>
      <span class="nav-menu-item" :class="{'select': activeIndex === 2 }"
        @click="navMenuSelect(2, `/bigdata/overview/${id}`)">
        项目概况
      </span>
      <span class="nav-menu-item" :class="{'select': activeIndex === 3 }"
        @click="navMenuSelect(3, `/bigdata/monitor/${id}`)">
        工地现场监控
      </span>
    </div>
    <div class="nav-menu-group"></div>
    <div class="nav-menu-group" style="justify-content: space-around;">
      <span class="nav-menu-item" :class="{'select': activeIndex === 4 }"
        @click="navMenuSelect(4, `/bigdata/tasks/${id}`)">
        施工任务分解图
      </span>
      <span class="nav-menu-item" :class="{'select': activeIndex === 5 }"
        @click="navMenuSelect(5, `/bigdata/timeline/${id}`)">
        验收时间轴
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NavMenu',
  props: {
    activeIndex: {
      type: Number,
      default: 1,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    navMenuSelect(index, path) {
      this.$router.push({ path });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/theme/app.scss';

  .nav-menu {
    padding: 0rem 0rem 1rem 0rem;
    display: flex;
    color: $font-color;
    &-group {
      width: 33.33333%;
      display: flex;
      justify-content: space-between;
    }
    &-item {
      cursor: pointer;
      color: #5CC2CB;
      height: 2rem;
      line-height: 2rem;
      vertical-align:middle;
      &.select {
        color: #7FF4FF;
        font-weight: bold;
        text-shadow: 0px 0px 8px #7FF4FF;
      }
    }
  }
</style>
